var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    class: _vm.info.class,
    attrs: {
      "title": _vm.$t(`${_vm.info.title}`),
      "visible": _vm.info.show,
      "append-to-body": true,
      "show-close": _vm.showClose,
      "top": "8vh",
      "close-on-click-modal": false,
      "width": _vm.width
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      },
      "open": _vm.openDialog,
      "closed": _vm.closeDialog
    }
  }, [_c('div', {
    staticClass: "contents"
  }, [_vm._t("default"), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.content)
    }
  })], 2), _vm.info.customTitle ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("head")], 2) : _vm._e(), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.info.showRemindMe && !_vm.info.hideBottom,
      expression: "!info.showRemindMe && !info.hideBottom"
    }],
    staticClass: "bottomText",
    class: {
      visible: !_vm.info.bottomText || _vm.info.loading
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('voiceCommand.summaryTime')) + " "), _c('span', [_vm._v(_vm._s(_vm.info.startTime))]), _vm._v(" - "), _c('span', [_vm._v(_vm._s(_vm.info.endTime))]), _vm._v(". ")]), _vm.info.showRemindMe ? _c('div', {
    staticClass: "checkboxContainer"
  }, [_c('el-checkbox', {
    staticClass: "greenStyle",
    on: {
      "change": _vm.handleCheckboxChange
    },
    model: {
      value: _vm.checkRemindMe,
      callback: function ($$v) {
        _vm.checkRemindMe = $$v;
      },
      expression: "checkRemindMe"
    }
  }, [_vm._v(" Do not remind me again ")])], 1) : _vm._e(), _c('div', {
    staticClass: "buttonBox"
  }, [!_vm.info.hideCancel && _vm.info.cancel ? _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t(`${_vm.info.cancel}`)))]) : _vm._e(), !_vm.info.hideSave && _vm.info.save ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t(`${_vm.info.save}`)))]) : _vm._e(), _vm.info.showGotIt ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.gotIt
    }
  }, [_vm._v(_vm._s(_vm.$t(`${_vm.info.gotIt}`)))]) : _vm._e(), _vm._t("foot")], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };